import { SidepanelSectionViewMore } from './section-view-more'

/** A "View more" under a run of rows on the To-dos Home, lined up with the rows' titles. */
export function HomeViewMore({ onClick }: { onClick: () => void }) {
  return (
    <SidepanelSectionViewMore
      // The rows' 1px border and 12px padding, then the 24px a mark and its gap
      // take, so the label starts where their titles do without one of its own.
      className="text-foreground-secondary hover:text-foreground border border-transparent px-3 pl-9 font-normal"
      // `null`, not left unset: the base would fall back to its own arrow.
      icon={null}
      onClick={onClick}
    />
  )
}
